"use client"

import { OpenAPI } from "@/api/client"
import { create } from "zustand"

type AuthState = {
  accessToken: string | null
  setAccessToken: (token: string | null) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  setAccessToken: (token) => {
    OpenAPI.TOKEN = token ?? undefined
    set({ accessToken: token })
  },
  clear: () => {
    OpenAPI.TOKEN = undefined
    set({ accessToken: null })
  },
}))
